const SECRET_KEY = process.env.NEXT_PUBLIC_ENCRYPTION_KEY || "ososs-store-secret-key";

export const encrypt = (text: string): string => {
  try {
    const textToEncrypt = encodeURIComponent(text);
    let result = "";
    for (let i = 0; i < textToEncrypt.length; i++) {
      result += String.fromCharCode(
        textToEncrypt.charCodeAt(i) ^
          SECRET_KEY.charCodeAt(i % SECRET_KEY.length),
      );
    }
    return btoa(result);
  } catch (error) {
    console.error("Encryption failed", error);
    return text;
  }
};

export const decrypt = (encryptedText: string): string => {
  try {
    const text = atob(encryptedText);
    let result = "";
    for (let i = 0; i < text.length; i++) {
      result += String.fromCharCode(
        text.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length),
      );
    }
    return decodeURIComponent(result);
  } catch (e) {
    console.error("Decryption failed", e);
    return "";
  }
};
